import styled from 'styled-components';

const Container = styled.section`
margin: 0 auto;
max-width: 870px;
`;

export default Container;